// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","similarWrapper":"similarProjects_similarWrapper__anq0q","similarCards":"similarProjects_similarCards__NzrC8"};